<template>
  <div>
    <div class="ipsos-upload-container" v-show="item[urlModelName]">
      <template>
        <div class="ipsos-uploader progress-bar" v-if="loading">
          <Spin fix>
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          </Spin>
        </div>
        <div v-else-if="item[urlModelName]" class="ipsos-uploader">
          <div v-if="item[urlModelName]" class="upload-img">
            <img :src="ossUrl">
          </div>
          <div class="upload-tools">
            <div class="tool-t">
              <i v-show="item[urlModelName]" class="icon icon-del" @click="handleRemove()"></i>
            </div>
            <div class="tool-m">
              <div v-show="item[urlModelName]" class="tool" @click="handleView()">
                <i class="icon icon-view"></i>
                <span class="text">查看</span>
              </div>
              <div class="tool" @click="handleUpload()">
                <i class="icon icon-replace"></i>
                <span class="text">{{ item[urlModelName] ? '替换' : '上传' }}</span>
              </div>
            </div>
            <div class="tool-b">
              <span :title="item[nameModelName]" class="file-name text-overflow">
                {{item[nameModelName]}}
              </span>
            </div>
          </div>
        </div>
      </template>
    </div>
    <ipsos-image-upload v-show=false ref="upload" :urlField="urlField" :nameField="nameField" :item="item" :loading.sync="loading"></ipsos-image-upload>
    <Modal title="查看图片" v-model="visible">
      <img v-lazy="ossUrl" v-if="visible" style="width: 100%">
      <div slot="footer">
        <Button type="primary" @click="visible = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'ipsosImageViewer',
  props: ['item', 'urlField', 'nameField'],
  data () {
    let { urlField, nameField } = this
    urlField = urlField || 'imgUrl'
    nameField = nameField || 'imgName'
    return {
      urlModelName: urlField,
      nameModelName: nameField,
      loading: false,
      visible: false
    }
  },
  components: {},
  watch: {
  },
  computed: {
    ossUrl () {
      const imgUrl = this.item[this.urlModelName]
      if (imgUrl.includes('static/images')) {
        return imgUrl
      }
      if (imgUrl.indexOf('http') === -1) {
        return (`${this.$OSS_URL}` || process.env.OSS_URL) + imgUrl
      }
      return imgUrl
    }
  },
  methods: {
    handleView () {
      this.visible = true
    },
    handleRemove (ev) {
      const { item, urlModelName, nameModelName } = this
      if (this.$isOperable(item, ev)) {
        item[urlModelName] = ''
        item[nameModelName] = ''
      }
    },
    handleUpload (ev) {
      if (this.$isOperable(this.item, ev)) {
        this.$refs.upload.handleUpload()
      }
    }
  },
  created () {
  },
  mounted () {

  }
}
</script>
<style lang="scss">
  .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        position: relative;
        border: 1px solid #eee;
    }

  .question-container {
    .ipsos-upload-container {
      padding: 10px 0 20px 54px;
    }

    .option-container .ipsos-upload-container {
      padding: 10px 0 0 34px;
    }
  }

  .ipsos-uploader {
    height: 120px;
    width: 120px;
    position: relative;

    .icon {
      cursor: pointer;
      display: inline-block;
    }

    &:hover .upload-tools {
      display: block;
    }

    .upload-img, .upload-tools {
      width: 100%;
      height: 100%;
      position: absolute;
    }

    .upload-img {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        height: auto;
        width: auto;
        max-width: 100px;
        max-height: 120px;
      }
    }

    .upload-tools {
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.6);
      display: none;
      color: #fff;

      .tool-t {
        position: relative;
        height: 26px;
        .icon-del {
          position: absolute;
          top: 4px;
          right: 4px;
          width: 20px;
          height: 20px;
          background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGZpbGwtb3BhY2l0eT0iLjIiIGZpbGw9IiMwMDAiIGN4PSIxMCIgY3k9IjEwIiByPSIxMCIvPjxwYXRoIGQ9Ik0xMC4wNDEgOS4zMzRMMTQuMzc1IDVsLjcwNy43MDctNC4zMzQgNC4zMzQgNC4zMzQgNC4zMzQtLjcwNy43MDctNC4zMzQtNC4zMzQtNC4zMzQgNC4zMzRMNSAxNC4zNzVsNC4zMzQtNC4zMzRMNSA1LjcwNyA1LjcwNyA1bDQuMzM0IDQuMzM0eiIgZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9nPjwvc3ZnPg==);
        }
      }

      .tool-m {
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: -14px;

        .tool {
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 42px;
          height: 42px;
          margin-left: 14px;
          border: 1px solid #fff;
          border-radius: 4px;

          .icon {
            display: block;
          }

          .icon-view {
            display: block;
            width: 15px;
            height: 14px;
            background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTIuMzY4IDEwLjc5NmwyLjgwOS0yLjgxIDEuOTI5IDEuOTI5LTIuODEgMi44MSAxLjE1NyAxLjE1Ni01LjMzMiAxLjA5IDEuMDktNS4zMzIgMS4xNTcgMS4xNTd6bTEwLjM1Ni02LjVsLTIuODEgMi44MS0xLjkyOC0xLjkyOSAyLjgxLTIuODEtMS4xNTctMS4xNTZMMTQuOTcuMTJsLTEuMDkgNS4zMzItMS4xNTctMS4xNTd6IiBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=);
          }

          .icon-replace {
            width: 14px;
            height: 15px;
            background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQuNzEyIDEzLjIwMWwtNC4xNTQuNzY3LjgzOC00LjA4Mkw0LjcxMiAxMy4yek0xMS4yMjguMDU0TDkuNzQgMS41NGwzLjMxNiAzLjMxNiAxLjQ4OC0xLjQ4N0wxMS4yMjguMDU0ek0yLjE0IDkuMTQybDMuMzE2IDMuMzE2IDYuODU4LTYuODU3LTMuMzE2LTMuMzE2TDIuMTQgOS4xNDJ6IiBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=);
          }

          .text {
            font-size: 12px;
            line-height: 18px;
            margin-bottom: -2px;
          }
        }
      }

      .tool-b {
        text-align: center;

        .file-name {
          max-width: 80px;
          font-size: 12px;
        }
      }
    }
  }

  .progress-bar {
    line-height: 120px;
    position: relative;
    background: rgba(0, 0, 0, 0.9);
  }

/* .ipsos-upload-list {
  display: inline-block;
  width: 120px;
  height: 120px;
  text-align: center;
  line-height: 120px;
  border: 1px dashed #dcdee2;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  margin-right: 4px;
}
.ipsos-upload-list img {
  width: 100%;
  height: 100%;
}
.ipsos-upload-list-cover {
  border: none;
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.ipsos-upload-list:hover .ipsos-upload-list-cover {
  display: block;
}
.ipsos-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
} */
</style>



// WEBPACK FOOTER //
// src/plugin/element/DubuImageViewer.vue